// extracted by mini-css-extract-plugin
module.exports = {"text":"Skeleton_text__3AOEw","skeleton":"Skeleton_skeleton__3m_EO","MuiSkeleton-text":"Skeleton_MuiSkeleton-text__3MXGW","alignRight":"Skeleton_alignRight__1GuBR"};